import { FLEX_AO_DISPATCH_API_URL } from "../components/Shared/constant";

const FlexUcDispatchAPI = async (payload, accessToken) => {
    const responce = window.axios.post(FLEX_AO_DISPATCH_API_URL, payload, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded",
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default FlexUcDispatchAPI;